export default __webpack_public_path__ + "static/media/additional_purchase_icon.55b54949.svg";